export class HomeMenuEstiloModel {
    static COMPONENTE_BLOCO = 1
    static COMPONENTE_QUADRADO = 2

    componente

    constructor(componente = HomeMenuEstiloModel.COMPONENTE_QUADRADO) {
        this.componente = componente
    }
}